import { generate } from '../../../core/js/utils/componentUtils';
import { updateDeviceSizeSaga } from '../sagas/deviceSagas';

import { clientServerErrorTracking } from '../actions/analyticsActions';

import { TokenEventEmitter } from 'urbnTokenLib';
import { buildUrl } from '../utils/urlUtils';

export function attachEvents(store) {
    function checkSize() {
        store.runSaga(updateDeviceSizeSaga);
    }

    $(window).on('resize', _.debounce(checkSize, 2000));

    // needed because parsley has to be loaded deferred after jquery, so Parsley won't be defined
    // until after the document has loaded
    $(document).ready(() => {
        // Watch for parsley errors to display analytics event
        window.Parsley.on('field:error', (parsleyField) => {
            const errorSlug = _.get(parsleyField, 'domOptions.errorMessage', 'GENERAL_FORM_FIELD_ERROR');

            store.dispatch(clientServerErrorTracking(errorSlug));
        });

        const tokenEventEmitter = TokenEventEmitter.sharedInstance();

        tokenEventEmitter.on('token:blocked', function tokenBlocked() {
            const state = store.getState();
            const redirectURL = buildUrl(state, '/login', true);

            window.location = redirectURL;
        });
    });
}

export function init(store, overrides = {}) {
    const config = {
        attachEvents: attachEvents,
        name: 'windowComponent'
    };

    return generate(config, store, overrides);
}
